// obsolete use masking service instead
export class TheMaskedEmail
{

  public maskedEmail: string;

  constructor(private email: string)
  {
    this.maskedEmail = email.replace(/^(.)(.*)(.@.*)$/,
      (_, a, b, c) => a + b.replace(/./g, '*') + c
    );
  }
}